import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import copyToClipboard from '@functions/copyToClipboard'
import { confirmDelete } from '@functions/entity'

import useTrainingModule from '@hooks/useTrainingModule'

type TrainingModuleToolsProps = {
  trainingModulePayload: ReturnType<typeof useTrainingModule>,
}

const TrainingModuleTools = (props: TrainingModuleToolsProps) => {
  const { trainingModulePayload } = props

  const {
    callbacks: {
      createOrDuplicateTrainingModule,
      deleteTrainingModule: deleteFn,
    },
    loading,
    trainingModule,
    urls: { linkUrl },
  } = trainingModulePayload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { entityName: 'Training Module' },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        loading={loading}
        onClick={() => copyToClipboard(linkUrl)}
        size="medium"
      >
        Copy Link to Module
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        //@ts-expect-error
        marginTop="medium"
        loading={loading}
        onClick={() => createOrDuplicateTrainingModule()}
        size="medium"
      >
        Duplicate Training Module
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        loading={loading}
        //@ts-expect-error
        marginTop="medium"
        onClick={() => confirmDelete(confirmDeletePayload)}
        size="medium"
      >
        Delete Training Module
      </Button>
    </Tools>
  )
}

export default TrainingModuleTools
